<template>
  <div>
    <trip-planner-inputs :isFuture="isFuture" :isWidget="true"></trip-planner-inputs>
  </div>
</template>

<script>
import TripPlannerInputs from '@/components/TripPlannerInputs.vue'
import mixinCommon from '../mixins/common'

export default {
  name: 'trip-planner-widget',
  components: { TripPlannerInputs },
  props: {
    isFuture: Boolean
  },
  mixins: [mixinCommon],
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
    // this.$store.dispatch('geoLocation/getCurrentGeoLocation', {})
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.address-fields-container {
  position: relative;
  // border:solid 1px red;
  padding-right: 50px;
}
.address-field {
}
.address-fields-container .input-group {
  margin: 20px 0;
}
.input-group-text {
  width: 70px;
}
.swap-button {
  position: absolute;
  z-index: 9;
  right:0;
  top: 30%;
}
</style>



// WEBPACK FOOTER //
// src/components/TripPlannerWidget.vue